/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Special equipment of an insured object.   (bipro-datentypen::Sonderausstattung)     * `AlarmSystem`   - german: Alarmanlage   * `Immobilizer`   - german: Wegfahrsperre
 */
export const SpecialEquipmentType = {
  AlarmSystem: 'AlarmSystem',
  Immobilizer: 'Immobilizer',
} as const;
export type SpecialEquipmentType = (typeof SpecialEquipmentType)[keyof typeof SpecialEquipmentType];
